<template>
    <div class="content-body" style="padding-top: 6rem">
        <div class="container-fluid">
            <div class="page-titles">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Info</a></li>
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'Blog' }">Data Blog</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">{{ currentRouteName }}</a>
                    </li>
                </ol>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Form {{ currentRouteName }}</h4>
                        </div>
                        <div class="card-body">
                            <div class="basic-form">
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Judul
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.title" @input="generateSlug" type="text" class="form-control" placeholder="Judul Post" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Slug URL
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.slug" type="text" class="form-control" placeholder="Slug URL" readonly />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Kategori
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <select v-model="post.id_sub_kategori" class="form-control">
                                            <option v-for="kategori in kategoriList" :key="kategori.id" :value="kategori.id">
                                                {{ kategori.judul }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Thumbnail
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <div class="custom-file">
                                                <input @change="handleFileUpload" type="file" class="custom-file-input" />
                                                <label class="custom-file-label">{{ post.image ? post.image.name : "Pilih file" }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Image Caption
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.alt_image" type="text" class="form-control" placeholder="Input Caption Image" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Deskripsi
                                        <span class="text-danger">*</span>
                                    </label>
                                    <textarea ref="summernote" class="form-control summernote" id="deskripsi" v-model="post.deskripsi" rows="3"></textarea>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Keyword Tag
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input v-model="post.hastag" type="text" class="form-control" placeholder="Input Keyword Tag" />
                                    </div>
                                </div>

                                <div class="card-header2 mt-5 mb-3">
                                    <h4 class="card-title">Meta SEO</h4>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Meta Title
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            v-model="post.meta_title"
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': (post.meta_title?.length || 0) > 255 || (submitted && !(post.meta_title || '').trim()) }"
                                            placeholder="Input Meta Title"
                                        />
                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                            <div>
                                                <small v-if="(post.meta_title?.length || 0) > 255" class="text-danger font-weight-bold">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Karakter melebihi batas maksimal (Maks. 255 karakter)
                                                </small>
                                                <small v-else-if="submitted && !(post.meta_title || '').trim()" class="text-danger">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Meta Title wajib diisi
                                                </small>
                                            </div>
                                            <small :class="(post.meta_title?.length || 0) > 255 ? 'text-danger font-weight-bold' : 'text-muted'" class="ml-auto">
                                                {{ (post.meta_title || '').length }}/255
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Meta Description
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            v-model="post.meta_deskripsi"
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && !(post.meta_deskripsi || '').trim() }"
                                            placeholder="Input Meta Description"
                                        />
                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                            <div>
                                                <small v-if="submitted && !(post.meta_deskripsi || '').trim()" class="text-danger">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Meta Description wajib diisi
                                                </small>
                                            </div>
                                            <small class="text-muted ml-auto">
                                                {{ (post.meta_deskripsi || '').length }} karakter
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Meta Content
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            v-model="post.meta_content"
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && !(post.meta_content || '').trim() }"
                                            placeholder="Input Meta Content"
                                        />
                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                            <div>
                                                <small v-if="submitted && !(post.meta_content || '').trim()" class="text-danger">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Meta Content wajib diisi
                                                </small>
                                            </div>
                                            <small class="text-muted ml-auto">
                                                {{ (post.meta_content || '').length }} karakter
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Meta Name
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <input
                                            v-model="post.meta_name"
                                            type="text"
                                            class="form-control"
                                            :class="{ 'is-invalid': (post.meta_name?.length || 0) > 255 || (submitted && !(post.meta_name || '').trim()) }"
                                            placeholder="Input Meta Name"
                                        />
                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                            <div>
                                                <small v-if="(post.meta_name?.length || 0) > 255" class="text-danger font-weight-bold">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Karakter melebihi batas maksimal (Maks. 255 karakter)
                                                </small>
                                                <small v-else-if="submitted && !(post.meta_name || '').trim()" class="text-danger">
                                                    <i class="fa fa-exclamation-circle mr-1"></i>Meta Name wajib diisi
                                                </small>
                                            </div>
                                            <small :class="(post.meta_name?.length || 0) > 255 ? 'text-danger font-weight-bold' : 'text-muted'" class="ml-auto">
                                                {{ (post.meta_name || '').length }}/255
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-form-label">
                                        Status
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="col-sm-9">
                                        <select v-model="post.is_publish" class="form-control">
                                            <option value="true">Publish</option>
                                            <option value="false">Unpublish</option>
                                        </select>
                                    </div>
                                </div>
                                <button type="button" @click="goBack" class="btn btn-warning btn-sm mr-1">Kembali</button>
                                <button type="button" @click="submit" class="btn btn-primary btn-sm mr-1">Simpan</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, onMounted, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../axios";

export default {
    name: "Tambah Event Recap",
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const summernote = ref(null);
        const currentRouteName = computed(() => router.name);
        const post = ref({
            title: "",
            slug: "",
            image: null,
            alt_image: "",
            deskripsi: "",
            hastag: "",
            meta_title: "",
            meta_deskripsi: "",
            meta_content: "",
            meta_name: "",
            is_publish: "true",
            user: null,
            id_kategori: 5,
            id_sub_kategori: null,
        });

        const submitted = ref(false);

        const kategoriList = ref([]);
        const token = computed(() => store.state.token);
        const id_kategori = post.value.id_kategori;
        const fetchUser = async () => {
            try {
                const response = await axiosInstance.get("/user", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                if (response.status === 200) {
                    post.value.user = response.data.id;
                } else {
                    Swal.fire({
                        title: "Error",
                        text: error.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    }).then(() => {
                        store.dispatch("setAuth", false);
                        store.dispatch("setToken", { token: null, expiry: null });
                        localStorage.clear();
                        window.location.href = "/";
                    });
                    //throw new Error('Failed to fetch user data');
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error.message,
                    icon: "error",
                    confirmButtonText: "OK",
                }).then(() => {
                    store.dispatch("setAuth", false);
                    store.dispatch("setToken", { token: null, expiry: null });
                    localStorage.clear();
                    window.location.href = "/";
                });
            }
        };

        const sub_kategori = async () => {
            try {
                const response = await axiosInstance.get(`/kat-sub/${id_kategori}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });
                if (response.status === 200) {
                    kategoriList.value = response.data.data;
                } else {
                    Swal.fire({
                        title: "Error",
                        text: error.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                    //throw new Error('Failed to fetch user data');
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error.message,
                    icon: "error",
                    confirmButtonText: "OK",
                }).then(() => {
                    store.dispatch("setAuth", false);
                    store.dispatch("setToken", { token: null, expiry: null });
                    localStorage.clear();
                    window.location.href = "/";
                });
            }
        };

        const handleFileUpload = (event) => {
            const file = event.target.files[0];
            const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes

            if (!validTypes.includes(file.type)) {
                Swal.fire({
                    title: "Invalid File Type",
                    text: "Please select an image with format jpeg, jpg, png, or svg.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            if (file.size > maxSize) {
                Swal.fire({
                    title: "File Too Large",
                    text: "Please select an image smaller than 2MB.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            post.value.image = file;
        };

        const goBack = () => {
            router.push({ name: "Event Recap" });
        };

        const checkTitleExistence = async () => {
            try {
                const response = await axiosInstance.get(`/blog-slug/${post.value.slug}`, {
                    headers: {
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                console.log("Response data:", response.data);

                // Check if the response indicates the title already exists
                if (response.data.success && response.data.message === "Title Sudah Digunakan") {
                    Swal.fire({
                        title: "Warning",
                        text: "The slug already exists, please choose another title.",
                        icon: "warning",
                        confirmButtonText: "OK",
                    });
                    post.value.slug = ""; // Clear the slug if it exists
                }
            } catch (error) {
                console.error("Error checking slug existence", error);
            }
        };

        const generateSlug = async () => {
            post.value.slug = post.value.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");

            await checkTitleExistence();
        };

        const submit = async () => {
            submitted.value = true;

            // Validasi Meta SEO: Required
            if (
                !(post.value.meta_title || "").trim() ||
                !(post.value.meta_deskripsi || "").trim() ||
                !(post.value.meta_content || "").trim() ||
                !(post.value.meta_name || "").trim()
            ) {
                Swal.fire({
                    title: "Peringatan",
                    text: "Semua kolom Meta SEO yang bertanda (*) wajib diisi!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return;
            }

            // Validasi Meta SEO: Max 255 Karakter
            if ((post.value.meta_title || "").length > 255) {
                Swal.fire({
                    title: "Peringatan",
                    text: `Meta Title melebihi batas maksimal (${(post.value.meta_title || "").length}/255 karakter)!`,
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return;
            }

            if ((post.value.meta_name || "").length > 255) {
                Swal.fire({
                    title: "Peringatan",
                    text: `Meta Name melebihi batas maksimal (${(post.value.meta_name || "").length}/255 karakter)!`,
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return;
            }

            post.value.deskripsi = $("#deskripsi").summernote("code");
            const formData = new FormData();
            formData.append("title", post.value.title);
            formData.append("slug", post.value.slug);
            formData.append("alt_image", post.value.alt_image);
            formData.append("deskripsi", post.value.deskripsi);
            formData.append("hastag", post.value.hastag);
            formData.append("meta_title", post.value.meta_title);
            formData.append("meta_deskripsi", post.value.meta_deskripsi);
            formData.append("meta_content", post.value.meta_content);
            formData.append("meta_name", post.value.meta_name);
            formData.append("is_publish", post.value.is_publish);
            formData.append("user", post.value.user);
            formData.append("id_kategori", id_kategori);
            formData.append("id_sub_kategori", post.value.id_sub_kategori);
            if (post.value.image) {
                formData.append("image", post.value.image);
            }

            try {
                const response = await axiosInstance.post("/blog", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        title: "Success",
                        text: "Data created successfully!",
                        icon: "success",
                        confirmButtonText: "OK",
                    }).then(() => {
                        goBack();
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Error creating data",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: `Error: ${error.message}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        };

        onMounted(async () => {
            await fetchUser();
            await sub_kategori();
            await nextTick();
            $(summernote.value).summernote({
                height: 200,
                callbacks: {
                    onChange: (contents) => {
                        post.value.deskripsi = contents;
                    },
                },
            });
        });

        watch(
            () => post.value.id_kategori,
            async (newIdKategori, oldIdKategori) => {
                if (newIdKategori !== oldIdKategori) {
                    await sub_kategori();
                    post.value.id_sub_kategori = null; // Reset sub kategori
                }
            }
        );

        return {
            currentRouteName,
            post,
            kategoriList,
            handleFileUpload,
            generateSlug,
            submit,
            goBack,
            summernote,
            submitted,
        };
    },
};
</script>
